<template>
    <div v-show="isInactiveNewLocationModalVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_1">
                                <h5 class="modal-title">Add New Location</h5>
                            </div>
                            <div class="maheading_2">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="col-9">
                                            <p class="success-msg">Success!</p>
                                            <p class="success-note">
                                                <i class="fa fa-check-circle-o"></i>Inactive Account Created
                                            </p>
                                        </div>
                                        <div class="col-3 mt-3">
                                            <img src="@/assets/enterprise/Required_Rocket_Image_106x101.png" width="70" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row list_row_margin">
                                <div class="col-12 text-center">
                                    <p class="font-weight-bold">What Happens Now?</p>
                                </div>
                                <div class="col-12">
                                    <ul class="list_items">
                                        <li>Account can be assigned pre-program users</li>
                                        <li>You can purchase a subscription for the account</li>
                                        <li>You can assign the account to users for reporting purposes</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row gotoBtn justify-content-md-center">
                                <div class="col-4">
                                    <button type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="openSidebar(accountId)">Go to Account</button>
                                </div>
                            </div>
                            <div class="row mt-4 justify-content-md-center">
                                <div class="col-4">
                                    <button type="button" class="btn btn-sm btn-blue closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <EnterpriseAdminOverlaySidebar
            :isModalVisible="isModalVisible" 
            @close="closeSidebar"
            ref="location_sidebar" 
            readOnly="" 
        />

    </div>
</template>
<script>
import router from '../../router/index.js';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';

export default {
    props: ['isInactiveNewLocationModalVisible', 'accountId'],
    data() {
        return {
            loading: false,
            isModalVisible: false,
        }
    },
    components: {
        EnterpriseAdminOverlaySidebar,
    },
    methods: {
        closeModal() {
            let routeData = this.$router.resolve({name: 'locations'});
            window.open(routeData.href, '_self');
        },
        openSidebar(accountId) {
            this.isModalVisible = true;
            this.$refs.location_sidebar.getLocationDetail(accountId);
        },
        closeSidebar() {
            this.isModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}
.success-msg { font-size:  1.1rem; font-weight: 900;}
.success-note i { font-size: 1.05rem; margin-right: 10px; }
.gotoBtn { margin-top: 4rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.list_row_margin { margin: 5rem 0; }
.list_items { list-style-type: decimal; }
.list_items li { margin: 15px 0; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/inactive_new_location_modal.vue